import { useState } from 'react';
import { KTSVG } from 'src/_metronic/helpers/components/KTSVG';
import { getBannerSize } from '../../utils/banner-size';
import ImageUploadModal from '../Modal';

type VendorLogoType = {
  mobileDevice: boolean;
  logo: any;
  templateId: number;
};

export default function VendorLogo(props: VendorLogoType) {
  const { mobileDevice, logo, templateId } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [bannerResponse, setBannerResponse] = useState<any>([]);
  // Etiket yüklenecek görselin ölçüsüdür (max_width / ratio). Kutu boyutu sabit kalır: storefront logoyu da sabit boyutta gösteriyor.
  const logoSize = getBannerSize(logo?.ruleSet);
  return (
    <>
      <ImageUploadModal
        show={modalOpen}
        handleClose={() => setModalOpen(false)}
        maxSize={logo?.ruleSet?.max_size}
        allowTypes={logo?.ruleSet?.type}
        itemTypeId={logo?.id}
        templateId={templateId}
        sortIndex={0}
        setBannerResponse={setBannerResponse}
        maxWidth={logo?.ruleSet?.max_width}
      />
      <div
        onClick={() => setModalOpen(true)}
        className={`d-flex bg-light border border-secondary rounded-circle align-items-center justify-content-center ${mobileDevice ? 'mt-n6' : 'mt-n15'} cursor-pointer`}
        style={{ width: mobileDevice ? '88px' : `${logo?.ruleSet?.max_width || '147'}px`, height: mobileDevice ? '88px' : `${logo?.ruleSet?.max_width || '147'}px` }}
      >
        {bannerResponse?.[0]?.image ? (
          <img src={bannerResponse?.[0]?.image} alt="banner" className="w-100 h-100 object-fit-cover rounded-circle" />
        ) : logo?.banners?.[0]?.image ? (
          <img src={logo?.banners?.[0]?.image} alt="banner" className="w-100 h-100 object-fit-cover rounded-circle" />
        ) : (
          <div className="d-flex flex-column gap-2 align-items-center">
            <KTSVG path="/media/icons/duotone/Files/Upload.svg" className="svg-icon-1 svg-icon-primary" />
            <span className="text-muted fs-8">
              {logoSize
                ? `${logoSize.width} X ${logoSize.height}`
                : `${mobileDevice ? '88' : logo?.ruleSet.max_width || '147px'} X ${mobileDevice ? '88' : logo?.ruleSet.max_width || '147px'}`}
            </span>
            <span className="text-primary fs-9 text-center">Yükleme yapmak için dokunun.</span>
          </div>
        )}
      </div>
    </>
  );
}
